import { createFileRoute } from "@tanstack/react-router";
import { LoginLayout } from "~/routes/_login/route";
import { SignInPage } from "~/routes/_login/sign-in";

export const Route = createFileRoute("/__main/$locale/sign-in")({
  component: function LocaleSignIn() {
    return (
      <LoginLayout>
        <SignInPage />
      </LoginLayout>
    );
  },
});
